export const CurrencyCode = Object.freeze({
  USD: 'USD',
  INR: 'INR',
  BRL: 'BRL',
  EUR: 'EUR',
  CNY: 'CNY',
});

export const VByVRequiredCurrencyCodes = Object.freeze([CurrencyCode.INR]);
